import { BooleanParameterSchema, Interpolation, RealParameterSchema, Unit } from "./defaults";
import { Xml } from "@opendaw/lib-xml";
import { asDefined } from "@opendaw/lib-std";
import { Interpolation as OpenDAWInterpolation, semitoneToHz } from "@opendaw/lib-dsp";
export var ParameterEncoder;
(function (ParameterEncoder) {
    ParameterEncoder.bool = (id, value, name) => Xml.element({
        id, name, value
    }, BooleanParameterSchema);
    ParameterEncoder.linear = (id, value, min, max, name) => Xml.element({
        id, name, min, max, value, unit: Unit.LINEAR
    }, RealParameterSchema);
    ParameterEncoder.normalized = (id, value, min, max, name) => Xml.element({
        id, name, min, max, value, unit: Unit.NORMALIZED
    }, RealParameterSchema);
})(ParameterEncoder || (ParameterEncoder = {}));
export var ParameterDecoder;
(function (ParameterDecoder) {
    ParameterDecoder.readValue = (schema) => {
        if (schema.unit === Unit.LINEAR) {
            return schema.value;
        }
        else if (schema.unit === Unit.NORMALIZED) {
            const min = asDefined(schema.min);
            const max = asDefined(schema.max);
            return (schema.value - min) / (max - min);
        }
        else if (schema.unit === Unit.SEMITONES) {
            return semitoneToHz(schema.value);
        }
        return schema.value;
    };
})(ParameterDecoder || (ParameterDecoder = {}));
export var TempoAutomationConverter;
(function (TempoAutomationConverter) {
    /**
     * Converts a normalized value (0-1) to BPM using the given min/max range.
     */
    TempoAutomationConverter.normalizedToBpm = (normalized, minBpm, maxBpm) => minBpm + normalized * (maxBpm - minBpm);
    /**
     * Converts a BPM value to normalized (0-1) using the given min/max range.
     */
    TempoAutomationConverter.bpmToNormalized = (bpm, minBpm, maxBpm) => (bpm - minBpm) / (maxBpm - minBpm);
    /**
     * Converts openDAW interpolation type to DawProject interpolation.
     * - "none" (hold/step) → Interpolation.HOLD
     * - "linear" or "curve" → Interpolation.LINEAR
     */
    TempoAutomationConverter.toDawProjectInterpolation = (interpolation) => interpolation.type === "none" ? Interpolation.HOLD : Interpolation.LINEAR;
    /**
     * Converts DawProject interpolation to openDAW interpolation type.
     * - Interpolation.HOLD → Interpolation.None
     * - Interpolation.LINEAR → Interpolation.Linear
     */
    TempoAutomationConverter.fromDawProjectInterpolation = (interpolation) => interpolation === Interpolation.HOLD ? OpenDAWInterpolation.None : OpenDAWInterpolation.Linear;
})(TempoAutomationConverter || (TempoAutomationConverter = {}));
